import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { XCircleIcon, AlertTriangleIcon } from 'lucide-react';
export function Problem() {
  const failedAttempts = ['Las pastillas solo "apagan la alarma" del dolor pero no detienen el incendio de la inflamación.', 'Las dietas de "hospital" son imposibles de seguir y no tienen el sabor de nuestra cultura.', 'El ejercicio tradicional es de demasiado impacto y termina lastimándote más de lo que te ayuda.', 'Ignorar el problema hace que el espacio entre tus huesos se reduzca, acercándote a una cirugía innecesaria.'];
  return <section className="py-16 px-6 bg-brand-creamDark" data-id="element-112">
      <div className="max-w-3xl mx-auto" data-id="element-113">
        <FadeIn data-id="element-114">
          <div className="flex items-center justify-center mb-6" data-id="element-115">
            <AlertTriangleIcon className="w-10 h-10 text-brand-terracotta mr-4" data-id="element-116" />
            <h2 className="text-3xl md:text-4xl font-bold text-center" data-id="element-117">
              El Ciclo Peligroso
            </h2>
          </div>
          <p className="mb-10 text-center" data-id="element-118">
            La mayoría de las mujeres de nuestra generación quedan atrapadas en
            un ciclo peligroso. Toman analgésicos para poder caminar, pero esos
            químicos irritan el estómago y dañan los riñones. Luego, el dolor
            regresa con más fuerza porque la causa raíz —la inflamación
            sistémica— sigue ahí, desgastando tu cartílago día tras día.
          </p>
          <p className="mb-8 text-center font-medium" data-id="element-119">
            Has intentado cremas que solo huelen fuerte, suplementos caros que
            no funcionan y el consejo de "descansar", que solo hace que tus
            articulaciones se oxiden más por falta de movimiento.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-120">
          <div className="bg-white rounded-2xl p-8 shadow-soft border-t-4 border-brand-terracotta" data-id="element-121">
            <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-122">
              ¿Por qué lo que has intentado no funcionó?
            </h3>
            <ul className="space-y-4" data-id="element-123">
              {failedAttempts.map((item, index) => <li key={index} className="flex items-start" data-id="element-124">
                  <XCircleIcon className="w-6 h-6 text-brand-terracotta shrink-0 mt-1 mr-4" data-id="element-125" />
                  <span data-id="element-126">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}